import React from 'react';
import { Link } from 'react-router-dom';

import styles from './archiverow.css';

function ArchiveRow({ titles, item }) {
	const archiveLink = item.internal_link ? `/work/${item.internal_link}` : item.archive_link;

	return (
		<tr className={styles.tr}>
			<td
				data-name={titles[0].title}
				className={styles.td}>
        {item.internal_link ?
				<Link className={styles.link} to={archiveLink}>
					<span className={styles.text}>{item.archive_year}</span>
				</Link>
        :
        <a className={styles.link} href={archiveLink} rel="noopener noreferrer" target="_blank">
          <span className={styles.text}>{item.archive_year}</span>
        </a>
        }
			</td>
			<td
				data-name={titles[1].title}
				className={styles.td}>
        {item.internal_link ?
				<Link className={styles.link} to={archiveLink}>
					<span className={styles.text}>{item.archive_work}</span>
				</Link>
        :
        <a className={styles.link} href={archiveLink} rel="noopener noreferrer" target="_blank">
          <span className={styles.text}>{item.archive_work}</span>
        </a>
        }
			</td>
			<td
				data-name={titles[2].title}
				className={styles.td}>
        {item.internal_link ?
				<Link className={styles.link} to={archiveLink}>
					{item.archive_role.map((role, i) =>
						<span className={styles.text} key={i}>{role.name}</span>
					)}
				</Link>
        :
        <a className={styles.link} href={archiveLink} rel="noopener noreferrer" target="_blank">
          {item.archive_role.map((role, i) =>
            <span className={styles.text} key={i}>{role.name}</span>
          )}
        </a>
        }
			</td>
			<td
				data-name={titles[3].title}
				className={styles.td}>
        {item.internal_link ?
				<Link className={styles.link} to={archiveLink}>
					{item.archive_studio.map((studio, i) =>
						<span className={styles.text} key={i}>{studio.name}</span>
					)}
				</Link>
        :
        <a className={styles.link} href={archiveLink} rel="noopener noreferrer" target="_blank">
          {item.archive_studio.map((studio, i) =>
            <span className={styles.text} key={i}>{studio.name}</span>
          )}
        </a>
        }
			</td>
			<td
				data-name={titles[4].title}
				className={styles.td}>
				<span className={styles.text}>
					{item.archive_link != '' ?
					<a rel="noopener noreferrer" target="_blank" href={item.archive_link} className={styles.link}>{item.archive_link_text}</a>
					: item.archive_link_text}
				</span>
			</td>
		</tr>
	);
}

export default ArchiveRow;



// WEBPACK FOOTER //
// ./src/components/ArchiveRow/ArchiveRow.js